"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        cursor: not-allowed;\n        opacity: 0.5;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    border: 0 none;\n    padding: 4px 10px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n\n    color: ", ";\n    background: ", ";\n\n    font-size: 12;\n    line-height: 16px;\n    font-family: ", ";\n    font-weight: 600;\n\n    border-top: 1px solid ", ";\n    border-left: 1px solid ", ";\n    margin-left: -1;\n\n    border-radius: 4px 0 0 0;\n\n    &:not(:last-child) {\n      border-right: 1px solid ", ";\n    }\n\n    & + * {\n      border-left: 1px solid ", ";\n      border-radius: 0;\n    }\n\n    ,\n    &:focus {\n      box-shadow: ", ";\n      outline: 0 none;\n    }\n\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var Container = styled_components_1["default"].div(function () {
  return {
    position: "absolute",
    bottom: 0,
    right: 0,
    maxWidth: "100%",
    display: "flex",
    zIndex: 1
  };
});
exports.ActionButton = styled_components_1["default"].button(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return styled_components_1.css(_templateObject2(), theme.palette.text["default"], theme.palette.background["default"], theme.typography.fontFamily, theme.palette.border["default"], theme.palette.border["default"], theme.palette.border["default"], theme.palette.border["default"], theme.shadows.boxShadow.input, disabled && styled_components_1.css(_templateObject3()));
});
exports.ActionButton.displayName = "ActionButton";

exports.ActionBar = function (_a) {
  var actionItems = _a.actionItems,
      props = __rest(_a, ["actionItems"]);

  return react_1["default"].createElement(Container, Object.assign({}, props), actionItems.map(function (_ref2, index) {
    var title = _ref2.title,
        onClick = _ref2.onClick,
        _ref2$disabled = _ref2.disabled,
        disabled = _ref2$disabled === void 0 ? false : _ref2$disabled;
    return (// eslint-disable-next-line react/no-array-index-key
      react_1["default"].createElement(exports.ActionButton, {
        key: index,
        onClick: onClick,
        disabled: disabled
      }, title)
    );
  }));
};